import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Input } from "@/components/ui/input";
import { useTheme } from "@/components/ui/theme-provider";

interface RadioWithOtherQuestionProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export const RadioWithOtherQuestion = ({ options, value, onChange }: RadioWithOtherQuestionProps) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  const handleRadioChange = (newValue: string) => {
    if (newValue === "Other") {
      onChange("Other");
    } else {
      onChange(newValue);
    }
  };

  const handleOtherTextChange = (text: string) => {
    if (text.trim()) {
      onChange(`Other: ${text}`);
    } else {
      onChange("Other");
    }
  };

  // Extract the "Other" text if it exists
  const otherText = value.startsWith("Other: ") ? value.substring(7) : "";
  // Determine if "Other" is selected
  const isOtherSelected = value === "Other" || value.startsWith("Other: ");

  return (
    <div className="space-y-3">
      <RadioGroup 
        onValueChange={handleRadioChange} 
        value={isOtherSelected ? "Other" : value} 
        className="space-y-3"
      >
        {options.map((option) => (
          <div key={option} className="flex items-center space-x-2">
            <RadioGroupItem 
              value={option} 
              id={option} 
              className="border-green-500 text-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white" 
            />
            <Label htmlFor={option} className="text-foreground">{option}</Label>
          </div>
        ))}
        <div className="flex items-center space-x-2">
          <RadioGroupItem 
            value="Other" 
            id="other" 
            className="border-green-500 text-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white" 
          />
          <Label htmlFor="other" className="text-foreground">Other</Label>
        </div>
      </RadioGroup>
      {isOtherSelected && (
        <Input
          type="text"
          value={otherText}
          onChange={(e) => handleOtherTextChange(e.target.value)}
          className={`mt-2 ${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border-green-500/30 text-foreground focus:border-green-500 focus:ring-green-500 text-base md:text-sm h-12 md:h-10`}
          placeholder="Please specify..."
        />
      )}
    </div>
  );
}; 